import React, { PureComponent } from 'react'
import _ from 'lodash'
import $ from 'jquery'
import 'fullcalendar'
import 'fullcalendar/dist/fullcalendar.css';
import 'fullcalendar/dist/locale/ja';
import './calendar.css'
import 'jquery-ui-required/ui/widgets/draggable'

import {
    isMobile
} from "react-device-detect";

// import '../commons/jquery.ui.touch'

import Dialog from 'material-ui/Dialog'

import FlatButton from 'material-ui/FlatButton';
import Divider from 'material-ui/Divider';
import * as colors from 'material-ui/styles/colors';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import moment from 'moment'

const fullCalendarConfig = {
  header: {
    left: 'prev,next today',
    center: 'title',
    right: 'month,agendaWeek,agendaDay'
  },
  defaultView: 'agendaWeek',
  navLinks: true,
  editable: true,
  allDayText: '',
  // allDaySlot: false,
  columnFormat: 'M/D [(]dd[)]',
  slotDuration: '00:15:00', 
  snapDuration: '00:00:01',
  slotLabelFormat: 'H:mm',
  eventTextColor: 'white',
  eventOrder: 'order',
  firstDay: 1,

  eventLimit: true,
  views: {
     month: {
       eventLimit: 3,
       displayEventEnd: 'true',
       timeFormat: 'H:mm',
       columnFormat: 'dd',
       fixedWeekCount: false
     }
  },
}

class Calendar extends PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      init: false,
    }
  }
  
  handleClick() {

    const {auth, onChangeWeek, editUserId} = this.props

    const view = $('#calendar').fullCalendar('getView');

    const targetDisp = view.name === 'agendaWeek' ? 'week' : view.name

    const currentDate = $('#calendar').fullCalendar('getDate');
    const start = currentDate.startOf(targetDisp).format('YYYYMMDDHHmmss')
    const end = currentDate.endOf(targetDisp).format('YYYYMMDDHHmmss')

    onChangeWeek(editUserId, start, end)
  }

  componentDidMount() {

    const {approvalDate, onDayClick, onEventClick, onWorkHolidayDrop, kenmeiCodes} = this.props
    const {calendar} = this.refs

      let prevTime;
      let currentTime;

    const config = Object.assign({}, fullCalendarConfig,
      {
        defaultDate: approvalDate ? approvalDate : moment(),
        eventClick: function(event) {

            if (isMobile) {

                prevTime = typeof currentTime === 'undefined' || currentTime === null
                    ? new Date().getTime() - 1000000
                    : currentTime;
                currentTime = new Date().getTime();

                if (currentTime - prevTime < 500) {
                    setTimeout(() => {
                        onEventClick(event)
                    }, 300)
                }

            } else {
                onEventClick(event)
            }
        },
        dayClick: function(date, allDay, jsEvent, view) {

            if (isMobile) {

                prevTime = typeof currentTime === 'undefined' || currentTime === null
                    ? new Date().getTime() - 1000000
                    : currentTime;
                currentTime = new Date().getTime();

                if (currentTime - prevTime < 500) {
                    setTimeout(() => {
                        onDayClick(kenmeiCodes)(date, allDay, jsEvent, view)
                    }, 300)
                }

            } else {
                onDayClick(kenmeiCodes)(date, allDay, jsEvent, view)
            }

        },
        eventRender: function (event, element) {
            element.eventTextColor = 'red'
        },
        // events: function(start, end, callback){
          // console.log(start.format('YYYY/MM/DD HH:mm:ss'))
          // console.log(end.format('YYYY/MM/DD HH:mm:ss'))
        // }

        droppable: true, // this allows things to be dropped onto the calendar

        eventDrop: function(event, delta, revertFunc) {
          revertFunc()
        },
        eventResize: function(event, delta, revertFunc) {
          revertFunc()
        },
        eventReceive: function(event) {

          $('#calendar').fullCalendar('removeEvents', event._id);

          const workHolidayId = event.workHolidayId
          const workHolidayDate = event.date
          const subHolidayDate = event.start.format('YYYY/MM/DD')
          const mode = event.mode

          onWorkHolidayDrop(workHolidayId, subHolidayDate, workHolidayDate, mode, false)
        },
        dayRender: function (date, cell) {

            cell.bind('dblclick', function() {
                window.alert("test")
            })

          const weekDay = date.weekday()
          if (weekDay === 0 || weekDay === 6) {
            //########################
            //休日に色を付ける場合はここ
            //########################
            // cell.css("background-color", "#ffebee");
          }
        }
        ,
        eventAfterRender: function (event, element) {

          let title = "<span style='color:__color__'>" + event.title + '</span>'

          if (event.kind == 2 && event.eventType != 'basic') {
          }

          let color = colors.white
          switch(event.kind) {
            case 2 :
              if (event.eventType != 'basic') {
                color = colors.red900
              }
              break
            case 4 :
            case 5 :
            case 10 :
            case 11 :
            case 6 :
            case 7 :
            case 8 :
            case 9 :
              color = colors.grey800
              break
            default:
          }

          if (event.approvalUserNames && event.approvalUserNames.length != 0) {
            const userNames = event.approvalUserNames.map(x => "(" + x + ")").join("<br/>")
            title = title + "<br/>" + userNames;
          }

          title = title.replace('__color__', color)

          element.find('.fc-title').text('')
          element.find('.fc-title').append(title)

          // element.find('.fc-title').text('')
          // element.find('.fc-title').append("test<br>test")
        }
        // eventDragStop: function (event, jsEvent, ui, view) {

        //   // if (isEventOverDiv(jsEvent.clientX, jsEvent.clientY)) {
        //   //   $('#calendar').fullCalendar('removeEvents', event._id);
        //   //   var el = $("<div class='fc-event'>").appendTo('#external-events-listing').text(event.title);
        //   //   el.draggable({
        //   //     zIndex: 999,
        //   //     revert: true,
        //   //     revertDuration: 0
        //   //   });
        //   //   el.data('event', { title: event.title, id: event.id, stick: true });
        //   // }
        // }

      })

      $(calendar).fullCalendar(config)

      $('.fc-agendaWeek-button,.fc-month-button,.fc-today-button,.fc-next-button,.fc-prev-button').click(() => {
        this.handleClick()
      })

  }
  
  componentWillReceiveProps(nextProps) {
    const nextEvents = nextProps.addEvents
    const events = this.props.addEvents

    if (!_.isEqual(nextEvents, events)) {
       const {calendar} = this.refs
       $(calendar).fullCalendar('renderEvents',
         nextEvents
       )
    }

    const nextRemoveEvents = nextProps.removeEvents
    const removeEvents = this.props.removeEvents

    if (!_.isEqual(nextRemoveEvents, removeEvents) && nextRemoveEvents) {
       const {calendar} = this.refs
       $(calendar).fullCalendar('removeEvents',
         (e) => {
           return nextRemoveEvents.indexOf(moment(e.start).format('YYYY/MM/DD')) >= 0
         }
       )
    }

  }

  componentDidUpdate() {

    // $('#external-events .fc-event').each(function () {
    //   $(this).draggable({
    //     zIndex: 999,
    //     revert: true,      // will cause the event to go back to its
    //     revertDuration: 0  //  original position after the drag
    //   });
    // });

    // const {
    //   workHolidayDates
    // } = this.props

    // workHolidayDates.map((x, i) => {
    //   const event = {
    //     date: x.date,
    //     mode: x.mode,
    //     workHolidayId: x.id,
    //   }
    //   $(`#external-events .workHoliday-${x.id}`).data('event', event);
    // })

  }

  render() {

    const {
      workHolidayDates
    } = this.props

    return (
      <div style={{ margin: '20px' }}>
        <div ref='calendar' id='calendar' />
      </div>
    )
  }
}

export default Calendar


// WEBPACK FOOTER //
// ./src/components/Calendar.js